import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllSheetTreeIdsByBooks = (bookIds: string[] | null) : string[] => {
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  let ids: string[] = [];
  bookIds?.forEach((bookId) => {
    const additionalIds = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].bookId === bookId);
    ids.push(...additionalIds);
  })

  return ids;
}

export default useAllSheetTreeIdsByBooks;
